export default __webpack_public_path__ + "static/media/icon_dollar.f46a93fe.svg";